import { useNavigate } from "react-router-dom";
import useApp from "../context/AppContext";

const Header = () => {
  const { signOff, usuario } = useApp();
  const navigate = useNavigate();
  const sair = () => {
    signOff();
    navigate("/login");
  };  
  const meusDados = () => {
    navigate("/dadosCadastrais");
  };
  const logo = require("../images/svg/logo_urbam.png");
  const user = require("../images/fotos/user.png");
  return (
    <div className="serv-header">
      <div className="serv-logo">
        <img src={logo} className="imageHome" alt="Logotipo" onClick={()=> navigate("/")} />
      </div>
      <div className="serv-titulo">
        <span className="lista-form-title">PORTAL DE FORNECEDORES</span>
      </div>
      <div className="serv-razsoc">
        <div>
          <h6 className="login-msgini">Bem-vindo(a)</h6>
          <h1 className="login-razsoc">{usuario.razaoSocial}</h1>
          <div className="login-menu">
            <button className="login-menu-meusdados" onClick={meusDados}>Meus dados</button>
            <span className="login-menu-separador"> - </span>
            <button className="login-menu-meusdados" onClick={sair}>
              Sair
            </button>
          </div>
        </div>

        <div className="div-foto">
          <img src={user} width="80" alt="Usuário" />
        </div>
      </div>
    </div>
  );
};

export default Header;
